export default __webpack_public_path__ + "static/media/hpdstats-landing.97e06304.png";